import { configureStore } from "@reduxjs/toolkit"

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('Service Worker registered with scope:', registration.scope);
            })
            .catch((error) => {
                console.log('Service Worker registration failed:', error);
            });
    });
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

const initialState = {
    scans: getCookie("scans"),
     deviceToken: document.getElementById("devtoken").value,
    host: document.getElementById("host").value,
    logoToken: "noToken",
    rank: getCookie("rank"),
    isConnected: true,
    wsToken: "",
    location: {ID: 0, children: [], multiLocation: false}
}

function appReducer (state = initialState, action) {
    const splitType = action.type.split("/")
    console.log(splitType)
    switch(splitType[0]){
        case "firstSlice":
            switch(splitType[1]){
                case "secondSlice":
                    console.log("hi")
                    return state
                default:
                    return state
            }
        case "scans":
            switch(splitType[1]){
                case "update":
                    console.log(action.payload)
                    return {...state, scans: action.payload}
            }
        case "company":
            switch(splitType[1]){
                case "updateLogo":
                    console.log(action.payload)
                    return {...state, logoToken: action.payload}
            }
        case "leaderboard":
            switch(splitType[1]){
                case "updateRank":
                    return {...state, rank: action.payload}
            }
        case "devToken":
            return {...state, deviceToken: action.payload}
        case "wsToken":
            return {...state, wsToken: action.payload}
        case "location":
            switch(splitType[1]){
                case "update":
                    return {...state, location: action.payload}
            }
        default:
            return state
    }

}

export const store = configureStore({reducer: appReducer})

store.dispatch({type: "firstSlice/secondSlice"})